<template>
  <v-row v-if="!!heading" align="center" justify="center">
    <v-col class="text-center" cols="12">
      <div class="heading-card">
        <v-card-text>
          <div class="section-heading font-weight-thin mb-4">
            {{ heading }}
          </div>
        </v-card-text>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['heading'],
};
</script>

<style>
.heading-card {
  display: inline-block;
}
</style>
